import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconKeyboardSolid from '../../../../assets/icons/font_awesome/keyboard-solid.svg?react';

export function ButtonShowAllShortcuts() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);
  const { google_email } = use_slice_user(['google_email']);

  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * EVENTS
   */

  function onClick() {
    dispatch(LOCAL__ui_set_boolean({ key: 'hints_shortcut_overlay_with_all_values_visible', value: true }));
  }

  /*
   * HTML
   */
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => set_is_hovered(true)}
      onMouseLeave={() => set_is_hovered(false)}
      className="cursor-pointer text-md flex items-center gap-3 mt-2 hover:text-bar-foreground-hover"
    >
      <IconKeyboardSolid className={`w-6 h-6 cursor-pointer  ${is_hovered ? 'text-bar-foreground-hover' : 'text-bar-foreground'}`} />
      {t(i18n_page_settings_user.tabs.ui.categories.shortcuts.button.show_all_shortcuts)}
    </div>
  );
}
